import { render, staticRenderFns } from "./form-text-area-prop.vue?vue&type=template&id=87602f5a&scoped=true&"
import script from "./form-text-area-prop.vue?vue&type=script&lang=js&"
export * from "./form-text-area-prop.vue?vue&type=script&lang=js&"
import style0 from "./form-text-area-prop.vue?vue&type=style&index=0&id=87602f5a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87602f5a",
  null
  
)

component.options.__file = "form-text-area-prop.vue"
export default component.exports